import { FunctionComponent } from "react";
import { Container, Paper, Typography, Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const SuccessContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(4, 0),
  minHeight: "calc(100vh - 64px)",
  display: "flex",
  alignItems: "center",
}));

const SuccessPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  maxWidth: "600px",
  margin: "0 auto",
  backgroundColor: "white",
  boxShadow: theme.shadows[3],
  textAlign: "center",
}));

const RegistrationSuccess: FunctionComponent = () => {
  const navigate = useNavigate();

  return (
    <SuccessContainer maxWidth="lg">
      <SuccessPaper elevation={3}>
        <Box sx={{ color: "success.main", mb: 2 }}>
          <CheckCircleOutlineIcon sx={{ fontSize: 60 }} />
        </Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Registration Successful!
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Thank you for registering with Church of God Cincinnati. We're excited to have you join our community.
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          You will receive a confirmation email shortly with further instructions.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate("/")}
          sx={{ mt: 2 }}
        >
          Return to Home
        </Button>
      </SuccessPaper>
    </SuccessContainer>
  );
};

export default RegistrationSuccess; 